export default "__VITE_ASSET__0d902063__"